<div
  id="commentsModal"
  tabindex="-1"
  role="dialog"
  class="modal fade modal-colored-header"
>
  <div class="modal-dialog modal-lg">
    <div style="background-color: #009">
      <div class="panel-heading headering">
        <h1>Comments History</h1>
        <button
          #closeCommentsModal
          type="button"
          class="close"
          data-dismiss="modal"
        >
          &times;
        </button>
      </div>
    </div>

    <div class="panel-body" style="background-color: white; color: black">
      <div class="col-md-12">
        <div *ngIf="isLoading" class="text-center my-4">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading comments...
        </div>
        <div *ngIf="!isLoading">
          <h4 class="bold">{{commentData?.fileName}}</h4>
          <ul class="timeline" *ngIf="!isLoading" style="margin: 0">
            <ng-container
              *ngIf="commentData?.comments?.length; else noComments"
            >
              <li
                class="timeline-item timeline-item-detailed"
                *ngFor="let c of commentData.comments"
              >
                <div class="timeline-date">
                  <span>{{ c.createdDate | date : "MMMM d, y" }}</span>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header" style="padding: 0">
                    <span class="timeline-time">{{
                      c.createdDate | date : "shortTime"
                    }}</span>
                    <div style="display: flex; align-items: center; gap: 10px">
                      <span class="timeline-autor ms-2">{{ c.userName }}</span>
                      <span
                        class="badge mt-1 mb-1"
                        [ngClass]="c.commentType | commentTypeBadge"
                        >{{ c.commentType | commentType }}</span
                      >
                    </div>
                  </div>
                  <p class="timeline-activity" style="margin-top: 8px">
                    {{ c.comment }}
                  </p>
                </div>
              </li>
            </ng-container>
            <ng-template #noComments>
              <li class="timeline-item">
                <div class="timeline-content">
                  <p>No comments</p>
                </div>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
